import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    // If there's a hash, scroll to the element with that id
    if (hash) {
      // Skip if hash contains error parameters (not a valid selector)
      if (hash.includes('error=') || hash.includes('error_code=') || hash.includes('error_description=')) {
        return;
      }
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    // Scroll to top immediately on route change
    // Use setTimeout to ensure DOM has updated after route change
    setTimeout(() => {
      // Scroll window
      window.scrollTo(0, 0);
      
      // Scroll all main elements (handles both mobile and desktop layouts)
      const mainElements = document.querySelectorAll('main');
      mainElements.forEach((mainElement) => {
        mainElement.scrollTop = 0;
      });

      // Also scroll any scrollable containers
      const scrollableContainers = document.querySelectorAll('[class*="overflow-y-auto"]');
      scrollableContainers.forEach((container) => {
        container.scrollTop = 0;
      });
    }, 0);
  }, [pathname, hash, search]);

  return null;
}

